import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#008bd0",
      primaryHover: "#005e9e",
    },
    logoImage: logo,
    backend: "https://vku.epaper-publishing-one.de/",
    directory: "/kiosk",
    header: {
      title: "Verband kommunaler Unternehmen e.V.",
      lineHeader: true
    },
    info: [
      {
      text: 'Impressum',
      link: 'https://www.vku.de/impressum/'
    },
      {
      text: 'Datenschutz',
      link: 'https://www.vku.de/datenschutzerklaerung/'
    },
  ],
  };